<template>
    <div>
        <h3>Neuen Chat eröffnen</h3>
        <div class="search" v-bind:class="showStartChat ? 'search--no-border-bottom' : ''">
            <input v-debounce="500" v-model.lazy="keywords" type="text" placeholder="Kundennummer/-name"/>
            <i class="fa fa-search" v-if="results.length === 0"></i>
            <i class="fa fa-close" v-if="results.length > 0" @click="resetSearch"></i>
            <div v-if="results.length">
                    <div class="searchResult" v-if="results.length" v-for="result in results" :key="result.id"
                         v-html="highlight(result.first_name + ' ' + result.last_name +  ' (Knr. ' + result.customer_identifier + ')')"
                         @click="setCurrentResult(result)"></div>
            </div>
        </div>
        <div v-if="showStartChat" @click="createNewChat" class="startChat">Chat mit {{this.currentResult.first_name
            + ' ' +
            this.currentResult.last_name}}
            starten
        </div>
    </div>
</template>

<script>
    import HttpService from '../http/HttpService'

    export default {
        name: 'Customersearch',
        props: ['clientId'],
        components: {},
        computed: {
          showStartChat: function() {
              return this.keywords && this.keywords.length && this.showActions && this.currentResult;
          }
        },
        data() {
            return {
                keywords: null,
                results: [],
                showActions: false,
                currentResult: null,
            }
        },

        watch: {
            keywords(after, before) {
                this.fetch();
            }
        },

        methods: {
            fetch() {
                this.currentResult = null;
                HttpService.searchCustomer(this.keywords, this.clientId)
                    .then((response) => {
                        this.results = response.data.customers;
                    })
                    .catch(error => {
                    });
            },
            highlight(text) {
                return text.replace(new RegExp(this.keywords, 'gi'), '<span class="highlighted">$&</span>');
            },
            setCurrentResult: function (result) {
                this.currentResult = result;
                this.showActions = true;

            },
            showErrorMessage: function (msg) {
                this.$emit('error', msg);
            },
            showSuccessMessage: function (msg) {
                this.$emit('success', msg);
            },
            resetSearch: function () {
                this.currentResult = null;
                this.results = [];
                this.keywords = "";
            },
            createNewChat: function () {
                if (this.currentResult) {

                    let customerName = this.currentResult.first_name + " " + this.currentResult.last_name;
                    this.$store.getters.getFireStore.createNewChat(this.currentResult.id, this.currentResult.client_id, customerName)
                        .then((response) => {
                            if (response.status === 'success') {
                                this.showSuccessMessage(response.message);
                            } else {
                                this.showErrorMessage(response.message);
                            }
                        })
                        .catch();
                    this.resetSearch();
                    return true;
                } else {
                    this.showErrorMessage("Es ist aktuell kein Suchergebnis ausgewählt!")
                    return false;
                }

            },
        },
        created() {

        }
    }
</script>

<style lang="scss" scoped>
    .search {
        background: #ebebeb;
        border-radius: 7px;
        position: relative;
        padding: 0 0 0 32px;
        margin-top: 1em;

        &--no-border-bottom{
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        i {
            position: absolute;
            top: 25px;
            left: 1em;
            transform: translateY(-50%);
        }

        input {
            outline: none;
            padding-left: 0;
            background: #ebebeb;
            // position: absolute;
            width: 100%;

            &,
            &::placeholder {
                color: #252525;
            }
        }
    }

    input {
        border-radius: 3px;
        border: none;
        padding: 14px;
        color: white;
        background: #6A6C75;
        width: 90%;
        font-size: 14px;

        &[type="checkbox"] {
            width: 20px;
        }
    }

    .highlighted {
        color: red;
    }

    .startChat {
        background-color: #86BB70;
        color: white;
        cursor: pointer;
        padding: 25px 15px 25px 15px;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;

        &:hover {
            background-color: #95d17b;
        }
    }

    .searchResult {
        cursor: pointer;
        width: 100%;
        font-size: 16px;

        &:last-of-type {
            padding-bottom: 15px;
        }
        &:hover {
        }
    }

    .fa-close {
        cursor: pointer;
    }
</style>
